import { SpeechProvider } from "../app/models/stt-chunked.model";

export const environment = {
  production: true,
  environment: 'Dev',
  cva_url: 'https://devcva-medtech.intellitekhealth.com/3000/cva/v1',
  loggerConfig: {
    ipResolutionEndPoint:
      'https://devcva-medtech.intellitekhealth.com/3000/cva/v1/client-logger/resolve_ip',
    loggerEndPoint:
      'https://devcva-medtech.intellitekhealth.com/3000/cva/v1/client-logger/add_log',
    debug: false,
  },
  cvaUI_url: 'https://devcva-medtech.intellitekhealth.com',
  settings: {
    locale: 'en-NZ',
    language: 'en-US',
    zoneIdentifier: 'NZ',
    utcOffset: '+12:00',
  },
  user_management_api_url: 'https://devcva-medtech.intellitekhealth.com/um/api',
  landingURL: 'facility-selection',
  unauthizedURL: 'auth/unauthorized',
  enc_pass: 'fa895a17cea6f35de3f4065a3faded938a884a019d2e1d479f5cfb2c30d1e6e7',
  enc_alg: 'aes-256-cbc',
  editableTranscripts: true,
  enableRtfEditor: true,
  TEST_PASSWORD: "TestPassword@123",
  TEST_OLD_PASSWORD: "TestOldPassword@123",
  RECOMMENDATIONS: {
    TASKS: true,
    MEDICATIONS: false,
    CLASSIFICATIONS: true,
    ACC_ELIGIBILITY: true
  },
  siteKey: '6LcPYYwtAAAAAIsqyBMxKkQfT1nJu7CqmOgPFmXw',
  sttService: {
    defaultProvider: 'audio-chunks' as SpeechProvider,
    audioChunks: {
      // Chunk window
      minRecordingSeconds: 40,            // a pause can end a chunk only after this long
      maxRecordingSeconds: 60,            // forced cut, even mid-speech
      silenceInMs: 1000,                  // pause that ends a chunk between 40 s and the soft-cut window
      softCutWindowSeconds: 10,           // last 10 s (from 50 s) accept a shorter pause: 40/60 gives (60-40)/2 = 10, so this is the largest effective value
      softCutSilenceInMs: 300,            // pause that ends a chunk inside that window
      overlapSeconds: 1.5,                // repeated audio after a forced cut (about 4–5 words; merge handles up to 8)

      // Upload queue (sized together, see the checks below)
      uploadTimeoutMs: 90000,             // per attempt
      audioFileMaxRetries: 2,             // backoff 1 s, 2 s
      audioFileMaxQueue: 8,               // chunks waiting or in flight, about 15 MB of audio

      // Chunk content / VAD
      minChunkInSec: 1,
      vadRms: 0.01,                       // minimum threshold only
      minVoicedSeconds: 0.3,              // keep low so a short last word ("yes") is not dropped

      // Auto-stop
      maxConsecutiveSilentChunks: 4,      // about 2.7–4 minutes of silence

      // chunk window for the notes screen (passed via the component inputs; not bound in record-transcription)
      minRecordingSecondsForNotesScreen: 8,
      maxRecordingSecondsForNotesScreen: 14,
    },
  }
};
